import React from 'react'

export class Categories extends React.PureComponent {
  render () {
    return <div className={'category__container'} {...this.props} />
  }
}

export class Category extends React.PureComponent {
  static defaultProps = {
    title: ' '
  }

  render () {
    const {
      title, iconSrc, ...props
    } = this.props
    return <div className={'category__item'} {...props}>
      {
        iconSrc
          ? <img className={'category__img'} src={iconSrc} alt='' />
          : <div className='category__icon'>{title[0]}</div>
      }
      <br />
      <div className='category__title'>
        {title}
      </div>
    </div>
  }
}
